import { CSS } from 'registration-flow-v2';

export const show: CSS = {
  display: 'block',
};

export const hide: CSS = {
  display: 'none',
};
